// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-swiper-wrapper {
    width: 100%;
}

.news-swiper-navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;

    margin-top: 24px;
}

/* Runde Buttons */

.news-swiper-button {
    width: 64px;
    height: 64px;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 0;
    border: 3px solid #858585;
    border-radius: 50%;
    background: transparent;

    cursor: pointer;
    transition:
        border-color 0.2s ease,
        opacity 0.2s ease,
        transform 0.2s ease;
}

.news-swiper-button:hover {
    border-color: #555;
    transform: scale(1.03);
}

.news-swiper-button:focus-visible {
    outline: 3px solid #222;
    outline-offset: 4px;
}

/* Pfeile ohne zusätzliches Icon */

.news-swiper-arrow {
    width: 17px;
    height: 17px;

    display: block;
    border-top: 4px solid #858585;
    border-right: 4px solid #858585;
}

.news-swiper-arrow-left {
    margin-left: 7px;
    transform: rotate(-135deg);
}

.news-swiper-arrow-right {
    margin-right: 7px;
    transform: rotate(45deg);
}

/* Zähler */

.news-swiper-pagination {
    position: static !important;

    width: auto !important;
    min-width: 126px;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;

    color: #858585;
    font-size: 27px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 3px;
}

.news-swiper-separator {
    font-weight: 600;
}

/* Deaktivierter Button */

.news-swiper-button.swiper-button-disabled {
    opacity: 0.35;
    cursor: default;
    transform: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/NewsSwiper.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET,gBAAgB;AACpB;;AAEA,kBAAkB;;AAElB;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;;IAEvB,eAAe;IACf;;;2BAGuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,kCAAkC;;AAElC;IACI,WAAW;IACX,YAAY;;IAEZ,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,WAAW;;AAEX;IACI,2BAA2B;;IAE3B,sBAAsB;IACtB,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yBAAyB;;AAEzB;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB","sourcesContent":[".news-swiper-wrapper {\n    width: 100%;\n}\n\n.news-swiper-navigation {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 32px;\n\n    margin-top: 24px;\n}\n\n/* Runde Buttons */\n\n.news-swiper-button {\n    width: 64px;\n    height: 64px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    padding: 0;\n    border: 3px solid #858585;\n    border-radius: 50%;\n    background: transparent;\n\n    cursor: pointer;\n    transition:\n        border-color 0.2s ease,\n        opacity 0.2s ease,\n        transform 0.2s ease;\n}\n\n.news-swiper-button:hover {\n    border-color: #555;\n    transform: scale(1.03);\n}\n\n.news-swiper-button:focus-visible {\n    outline: 3px solid #222;\n    outline-offset: 4px;\n}\n\n/* Pfeile ohne zusätzliches Icon */\n\n.news-swiper-arrow {\n    width: 17px;\n    height: 17px;\n\n    display: block;\n    border-top: 4px solid #858585;\n    border-right: 4px solid #858585;\n}\n\n.news-swiper-arrow-left {\n    margin-left: 7px;\n    transform: rotate(-135deg);\n}\n\n.news-swiper-arrow-right {\n    margin-right: 7px;\n    transform: rotate(45deg);\n}\n\n/* Zähler */\n\n.news-swiper-pagination {\n    position: static !important;\n\n    width: auto !important;\n    min-width: 126px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 14px;\n\n    color: #858585;\n    font-size: 27px;\n    font-weight: 700;\n    line-height: 1;\n    letter-spacing: 3px;\n}\n\n.news-swiper-separator {\n    font-weight: 600;\n}\n\n/* Deaktivierter Button */\n\n.news-swiper-button.swiper-button-disabled {\n    opacity: 0.35;\n    cursor: default;\n    transform: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
